import { getUiLayout } from "./layout";

/** Clear SafeFrame contents (keeps frame element for layout sync). */
export function clearOverlay(): void {
  const ui = getUiLayout();
  ui.clearShell();
  ui.overlay.style.pointerEvents = "none";
}

export function showHudChip(text: string): void {
  const ui = getUiLayout();
  ui.sync();
  ui.clearShell();
  const frame = ui.frame;
  frame.style.display = "flex";
  frame.style.alignItems = "flex-start";
  frame.style.justifyContent = "center";
  frame.style.padding = "var(--ui-space-padMd)";
  const chip = document.createElement("div");
  chip.className = "hud-chip";
  chip.textContent = text;
  frame.appendChild(chip);
}

export function setHudChipText(text: string): void {
  const chip = getUiLayout().frame.querySelector(".hud-chip");
  if (chip) chip.textContent = text;
  else showHudChip(text);
}
